<template>
  <div class="flex h-full w-full flex-col items-center justify-center gap-2 p-2">
    <Header
      :breadcrumbs="[
        {
          label: errorMessage,
        },
      ]"
    />
    <p class="px-2 text-xl">{{ errorMessage }}</p>
    <p class="px-2 text-lg text-gray-600">Gehe zurück zur Übersicht und wähle dort eine Lernbox aus</p>
    <GrayButton label="Zurück zur Übersicht" @click="clearError({ redirect: '/' })" />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const { error } = defineProps<{ error: NuxtError }>();

const errorMessage = computed(() => {
  if (error.data !== 'custom' && error.statusCode === 404) {
    return 'Seite nicht gefunden';
  }
  return error.statusMessage;
});
</script>
